/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';

export const setNudgeStep =
	(nudge: string): Action<State> =>
	({ getState, setState }) => {
		const { nudgeStep } = getState();

		if (nudge === nudgeStep) {
			return;
		}

		setState({ nudgeStep: nudge });
	};

export default setNudgeStep;
